import type { WritableAtom } from 'nanostores'

import { type MutableRefObject, useEffect } from 'react'

import type { ActionsStore } from './store'

export function useManageOpen(
	menuRef: MutableRefObject<HTMLDivElement | null>,
	store: ActionsStore
) {
	useEffect(() => {
		if (menuRef.current) {
			return manageState(menuRef.current, store.trigger)
		}
	}, [menuRef, store.trigger])
}

function manageState(
	menu: HTMLDivElement,
	savedTrigger: WritableAtom<HTMLElement | null>
) {
	/* 	function syncCLose(event: ToggleEvent) {
		console.log(event)
		if (event.oldState === 'open' && event.newState === 'closed') {
			savedTrigger.set(null)
			setTimeout(() => {
				console.log('____ RESET ___')
				savedTrigger.set(null)
			}, 400)
		}
	}

	// @ts-expect-error
	menu.addEventListener('toggle', syncCLose)
 */
	const unsubscribe = savedTrigger.subscribe((current, old) => {
		if (current === null) {
			return menu.hidePopover()
		}

		if (!old) {
			menu.showPopover()
		}

		//#669 passing menu.showPopover directly to eventListener is buggy, looks like it is changed over time
		menu.addEventListener('toggle', () => {
			menu.showPopover()
		}, { once: true })
		menu.hidePopover()
	})

	return () => {
		unsubscribe()

		/* // @ts-expect-error
		menu.removeEventListener('toggle', syncCLose) */
	}
}
